module.exports = __webpack_public_path__ + "static/img/logo.358ee3c6.png";